import { Navigate, useLocation, Outlet } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { UserRole } from '@/models/user.model'
import { paths } from '@/routes/path'

interface ProtectedRouteProps {
  children?: React.ReactNode
  roles?: UserRole[]
  redirectPath?: string
}

export function ProtectedRoute({ children, roles, redirectPath }: ProtectedRouteProps) {
  const { isAuthenticated, user, isLoading } = useAuth()
  const location = useLocation()
  const fallbackPath = redirectPath ?? paths.app.dashboard.absolute

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-secondary-200 border-t-primary-600" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  if (roles && user?.role && !roles.includes(user.role)) {
    return <Navigate to={fallbackPath} replace />
  }

  // If callers passed children (explicit wrapper), render them;
  // otherwise render nested routes via Outlet so this route can be used as a wrapper route.
  return <>{children ?? <Outlet />}</>
}
